<template>
<li 
  class="card" 
  :class="{
      'card--closed': !card.isShow,
      'card--complete': card.isComplete}" 
  @click="addCard(card)">
  <div class="card__front">
    <img :src="card.url" :alt="card.name">
  </div>

  <div class="card__back">
    <img :src="card.backUrl" alt="genius-school">
    <span class="card__number">{{ number }}</span>
  </div>
</li>
</template>

<script>
export default {
  props: ['card', 'number'],
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    addCard(card) {
      this.$emit('add-card', card)
    }
  }
}
</script>
